module.exports = __webpack_public_path__ + "static/bishop-technologies-logo-3e868486eb72c055cd87428f20a812e9.png";